// extracted by mini-css-extract-plugin
export default {"thumbnail":"thumbnail__PWwm-","image":"image__YUY5J","separator":"separator__ajOWx","text":"text__bpMIr","hover":"hover__qMO6t"};